import { RomcalLocale } from '@romcal/models/locale/romcal-locale.type';

export default {
  sanctoral: {
    columban_of_luxeuil_abbot: 'Saint Columban, Abbot and Missionary', // TODO: This key should be removed after one can add titles within celebration definions
    willibrord_of_utrecht_bishop: 'Saint Willibrord, Bishop and Missionary', // TODO: This key should be removed after one can add titles within celebration definions
  },
} as RomcalLocale;
